import { Pipe, PipeTransform } from '@angular/core';
import { Shop } from '@us/web/shared/data-access';
import { map, Observable, timer } from 'rxjs';

@Pipe({
    name: 'openTimeToDayV2',
    standalone: true,
    pure: true
})
export class OpenTimeToDayV2Pipe implements PipeTransform {
    transform(shop: Shop | null): Observable<string | null> {
        return timer(0, 10 * 60 * 1000).pipe(
            map(() => {
                const day = new Date().getDay();
                const found = shop?.open_hours.find(e => e.day === day);

                if (!found) {
                    return null;
                }

                return found.periods.map(e => `${e.from} - ${e.to}`).join(', ');
            })
        );
    }
}
